/** Live telemetry poll interval (ms) — 30 seconds */
export const TELEMETRY_LIVE_POLL_MS = 30000;
